export default __webpack_public_path__ + "static/media/up-min.f98f9f7d.gif";